"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marginReducer = void 0;
var _redux = require("redux");
var _marginHistoryReducer = require("./marginHistoryReducer");
var _marginAccountInfoReducer = require("./marginAccountInfoReducer");
var _marginInstrumentReducer = require("./marginInstrumentReducer");
var _marginKVPInfoReducer = require("./marginKVPInfoReducer");
var _systemMarginEnabledReducer = require("./systemMarginEnabledReducer");
var _marginAccountEquityReducer = require("./marginAccountEquityReducer");
var _marginBalancesReducer = require("./marginBalancesReducer");
var _marginProductsReducer = require("./marginProductsReducer");
var _marginLeveragesReducer = require("./marginLeveragesReducer");
var _marginTransferAmountsReducer = require("./marginTransferAmountsReducer");
var _marginNotificationsReducer = require("./marginNotificationsReducer");
var _marginNavNotificationReducer = require("./marginNavNotificationReducer");
var marginReducer = exports.marginReducer = (0, _redux.combineReducers)({
  history: _marginHistoryReducer.marginHistoryReducer,
  instrument: _marginInstrumentReducer.marginInstrumentReducer,
  products: _marginProductsReducer.marginProductsReducer,
  accountInfo: _marginAccountInfoReducer.marginAccountInfoReducer,
  marginKVPInfo: _marginKVPInfoReducer.marginKVPInfoReducer,
  systemMarginEnabled: _systemMarginEnabledReducer.systemMarginEnabledReducer,
  marginEquity: _marginAccountEquityReducer.marginAccountEquityReducer,
  balances: _marginBalancesReducer.marginBalancesReducer,
  leverages: _marginLeveragesReducer.marginLeveragesReducer,
  transferAmounts: _marginTransferAmountsReducer.marginTransferAmountsReducer,
  notifications: _marginNotificationsReducer.marginNotificationsReducer,
  navNotification: _marginNavNotificationReducer.marginNavNotificationReducer
});